import { useEffect } from 'react'
import { Route, BrowserRouter as Router, Routes, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ThemeProvider } from './context/ThemeContext'
import { ToastProvider } from './context/ToastContext'
import DashboardPage from './pages/DashboardPage'
import DeveloperDocsPage from './pages/DeveloperDocsPage'
import HomePage from './pages/HomePage'
import OAuthCallbackPage from './pages/OAuthCallbackPage'
import PaymentCancelPage from './pages/PaymentCancelPage'
import PaymentSuccessPage from './pages/PaymentSuccessPage'
import ProfilePage from './pages/ProfilePage'
import TermsOfUsePage from './pages/TermsOfUsePage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import { trackPageView } from './utils/analytics'

// Component to track page views on route changes
function AnalyticsTracker() {
  const location = useLocation()

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search, document.title)
  }, [location])

  return null
}

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AnalyticsTracker />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/dashboard.html" element={<DashboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile.html" element={<ProfilePage />} />
              <Route path="/profile/payment-methods" element={<Navigate to="/profile#paymentmethods" replace />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/docs/developer" element={<DeveloperDocsPage />} />
              <Route path="/terms" element={<TermsOfUsePage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
            </Routes>
          </Router>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}

export default App
